import {
  LumabotFlowTemplate,
  LumabotTemplateItem,
  LumabotTempateItemProperties,
  LumabotTemplateItemAnswer,
} from 'types-model-repository/types.d';

export enum ELumaBotQuestionType {
  TwoFA = '2FA',
  Address = 'address',
  Date = 'date',
  Dropdown = 'dropdown',
  Email = 'email',
  Jump = 'jump',
  ManageAppointment = 'manage_appointment',
  MedicationSearch = 'medication_search',
  MultipleChoice = 'multiple_choice',
  PharmacySearch = 'pharmacy_search',
  PhoneNumber = 'phone_number',
  Scheduler = 'scheduler',
  Ssn = 'ssn',
  TemplateWelcome = 'template_welcome',
  Template = 'template',
  Text = 'text',
  YesNo = 'yes_no',
  ZipCode = 'zipcode',
  AvailabilityDetails = 'availability_details',
  NaturalLanguage = 'natural_language',
}

export enum ELumaBotFlowTemplateSource {
  System = 'system',
  User = 'user',
}
export enum ELumaBotFlowType {
  Welcome = 'welcome',
  AuthenticatePatient = 'authenticate-patient',
  SpeakWithStaff = 'speak-with-staff',
  SessionTimeout = 'session-timeout',
  KnockKnock = 'knock-knock',
  CulDeSac = 'cul-de-sac',
  Feedback = 'feedback',
  Error = 'error',
  Regular = 'regular',
  NoAvailabilities = 'no-availabilities',
}

export enum ELumaBotTemplateItemRedirectType {
  None = 'none',
  GoTo = 'goTo',
  GoToFlow = 'goToFlow',
  GoToPrevious = 'goToPrevious',
  ExternalUrl = 'externalUrl',
  Scheduler = 'scheduler',
  IsFinal = 'isFinal',
}

export interface ILumaBotTemplateItemAnswer
  extends Omit<LumabotTemplateItemAnswer, 'redirectType'> {
  redirectType?: ELumaBotTemplateItemRedirectType;
}
export interface ILumaBotTempateItemProperties
  extends Omit<LumabotTempateItemProperties, 'answers'> {
  answers?: ILumaBotTemplateItemAnswer[];
  showFilters?: boolean;
}
export interface ILumaBotTemplateItem
  extends Omit<LumabotTemplateItem, 'type' | 'redirectType' | 'properties'> {
  type: ELumaBotQuestionType;
  redirectType: ELumaBotTemplateItemRedirectType;
  properties: ILumaBotTempateItemProperties;
}
export interface ILumaBotTemplateBody {
  items?: ILumaBotTemplateItem[];
}

export interface ILumaBotFlowTemplate
  extends Omit<LumabotFlowTemplate, 'source' | 'template' | 'flowType'> {
  source: ELumaBotFlowTemplateSource;
  template?: ILumaBotTemplateBody;
  flowType: ELumaBotFlowType;
}
